/*@flow*/
import c from 'comps/Left2/panels';
import humanize from 'underscore.string/humanize';

export const panelMapping: {|
  ANALYSIS: string,
  FILTERS: string,
  LAYERS: string,
  LIST_VIEW: string,
  LOCATION_DETAILS: string,
  SEARCH: string,
  TUTORIAL: string,
|} = {
  [c.LIST_VIEW]: c.LIST_VIEW,
  [c.LOCATION_DETAILS]: c.LOCATION_DETAILS,
  SEARCH: 'SEARCH',
  [c.FILTERS]: c.FILTERS,
  [c.LAYERS]: c.LAYERS,
  [c.ANALYSIS]: c.ANALYSIS,
  [c.TUTORIAL]: c.TUTORIAL,
};

const defaultPanels: $Keys<typeof panelMapping>[] = Object.keys(panelMapping);
export default defaultPanels;

const toOption = v => ({
  label: humanize(v),
  value: v,
});

type OptionT = { label: string, value: $Keys<typeof panelMapping> };
export const PANELS_AS_OPTIONS: Array<OptionT> = defaultPanels.map<OptionT>(toOption);
